import React from "react";
import "./DrawerTutorialButton.modules.scss";
import { Button } from "@factorearth/component-library";
import { useTheme } from "hooks/useSingleton";
import { Location } from "hooks/useDrawer";
import { FiHelpCircle } from "react-icons/fi";

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
	helpColor: string;
	location: Location;
	setupDrawer: (location: Location | "") => void;
}

function DrawerTutorialButton(props: Props) {
	const { helpColor, location, setupDrawer, ...rest } = props;
	const color = useTheme();

	function openDrawer() {
		setupDrawer(location);
	}

	return (
		<Button colorPalette={color} onClick={openDrawer} className="help-button" variant="outlined" {...rest}>
			<FiHelpCircle size={28} />
		</Button>
	);
}

export default DrawerTutorialButton;
